export const exchangeErrorResolutionTypes = {
  manual: 'manual',
  refund: 'refund',
}
